export const CREATE_CATEGORY_TYPE = 'create_category_type';
export const EDIT_CATEGORY_TYPE = 'edit_category_type';
export const DELETE_CATEGORY_TYPE = 'delete_category_type';

export const CREATE_TUTORIAL_TYPE = 'create_tutorial_type';
export const EDIT_TUTORIAL_TYPE = 'edit_tutorial_type';
export const DELETE_TUTORIAL_TYPE = 'delete_tutorial_type';

export const TARGET_FILE_MAX_SIZE = 5 * 1024 * 1024;
export const PROVIDER_LOGO_CONTENT_TYPES = ['image/jpg', 'image/jpeg', 'image/png'];

export const TOPIC_CONSTRAINS = () => {
  const constrains = {
    title: {
      presence: {message: ' Title is required'},
      length: {
        maximum: 50,
        tooLong: 'Only 50 symbols allowed'
      }
    },
    description: {
      presence: {message: 'Description is required'}
    },
    tutorial_type: {
      presence: {message: 'Select type'}
    }
  }
  return constrains;
};

export const CPD_QUIZ_CONSTRAINS = {
  question: {
    presence: { message: 'Question is required' }
  },
  correct: {
    presence: { message: 'Correct is required' }
  }
};

export const RESOURCE_CONSTRAINS = {
  title: {
    presence: { message: 'Title is required' }
  },
  file: {
    presence: { message: 'File is required', allowEmpty: false }
  }
};

export const MCQ_THEME_CONSTRAINS = {
  title: {
    presence: { message: 'Title is required' }
  },
};

export const QUESTION_CONSTRAINS = {
  question: {
    presence: { message: 'Question is required' }
  },
};

export const SAMPLE_CONTENT_CONSTRAINS = {
  title: {
    presence: { message: 'Title is required' }
  },
  // file: {
  //   presence: { message: 'File is required', allowEmpty: true }
  // },
  // video_url: {
  //   presence: { message: 'Video URL is required', allowEmpty: true }
  // }
};


// WEBPACK FOOTER //
// ./src/constants/adminPupups.js